module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "设置规则名称",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "line_name",
      "rules": {
        required: true,
        message: '请填写规则名称',
        trigger: 'blur'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "最多30个字"
    },
    model: {
      value: (_vm.form.line_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "line_name", $$v)
      },
      expression: "form.line_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "充值面额"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.line_many),
      callback: function($$v) {
        _vm.$set(_vm.form, "line_many", $$v)
      },
      expression: "form.line_many"
    }
  }, [
    [_c('el-radio', {
      attrs: {
        "label": 50
      }
    }, [_vm._v("50元")])], _vm._v(" "), [_c('el-radio', {
      attrs: {
        "label": 100
      }
    }, [_vm._v("100元")])]
  ], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "format": "yyyy/MM/dd HH:mm:ss",
      "value-format": "timestamp",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "选择限购商品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [(_vm.hasSaveButton && !this.copy_flag) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74a25eda", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74a25eda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/recharge_offline/add.vue
// module id = 2828
// module chunks = 0